<template>
	<div class="box">
		<div class="communication" v-show="!zsgltdBool">
			<div class="fl Atlist retrieval">
				<div class="commtitle">
					<i class="c1 iconImg"></i>用户管理<span style="color:#4B4B4B ; font-weight: 600;">-医生列表</span>
				</div>
				<div class="retrievalipt">
					<el-input placeholder="用户姓名或手机号" prefix-icon="el-icon-search" v-model="input21">
					</el-input>
				</div>
				<div class="dqBox">
					<div class="gjjiansuo">
						<span @click="daysflagqbs" :class="{'active':daysflag==''}">全部</span>
						<span @click="daysflagdays" :class="{'active':daysflag==1}">今日</span>
						<span @click="daysflagweekdays" :class="{'active':daysflag==7}">近七天</span>
						<span @click="daysflagmonths" :class="{'active':daysflag==30}">近一月</span>
						<span @click="daysflagyears" :class="{'active':daysflag==365}">近一年</span>
					</div>
					<div class="gjjiansuo">
						<span @click="rz1" :class="{'active':rz=='0,1,2,4'}">全部</span>
						<span @click="rz2" :class="{'active':rz=='4'}">初级认证</span>
						<span @click="rz3" :class="{'active':rz=='1'}">高级认证</span>
						<span @click="rz4" :class="{'active':rz=='2'}">驳回认证</span><br/>
						<span @click="rzxy_7Fn" :class="{'active':rzxy_7==1}">初级认证<7天</span>
						<span @click="yzgqFn" :class="{'active':yzgq=='1'}">医嘱失效</span>
						<span @click="kpgqFn" :class="{'active':kpgq=='1'}">科普失效</span>
					</div>
					<div class="boxbtn">
						<button @click="jiansuoFn" :disabled="sousuo">
							搜索
						</button>
					</div>
					<!--<div class="boxbtn btnjj" >
						<button @click="getlistdc" :disabled="sousuo">
							导出列表
						</button>
					</div>-->
				</div>
				
			</div>
			<div class=" Attable">
				<div class="tablehzlist">
					<ul class="tableHeader">
						<li v-for="item in tableList">{{item.tableName}}</li>
					</ul>
					<!-- -->
					<div class="tabletd" @scroll="scrollEvent($event)">
						<ul class="tablecontent tableHeader" v-for="item in datalist">
							<li>
								<p>{{item.uName}}</p>
							</li>
							<li>{{item.uTel}}</li>
							<li>
								<p v-if="item.uChecked==0&&item.uName!=''">正在审核</p>
								<p v-if="item.uChecked==1">高级认证</p>
								<el-tooltip class="itemHover" effect="light" :content="'驳回原因: '+item.uCheckedRemark" placement="bottom">
							      <p v-show="item.uChecked==2" style="color: red;cursor: pointer;">审核未通过</p>
							    </el-tooltip>
								<p v-if="item.uChecked==0&&item.uName==''">尚未认证 </p>
								<p v-if="item.uChecked==4">初级认证<br/><span style="color: red;">体验剩余{{restTime(item.uCheckedTime,item.id)}}天</span> </p>
								<p v-if="item.uChecked==40">正在审核<br/>（初级升高级）</p>
								
							</li>
							<li class="tableA">
								<p v-if="item.uIsAccDpc==1">DPC</p>
								<p v-if="item.uIsAccPdm==1">PDM</p>
								<p v-if="item.uIsAccCep==1">CEP</p>
							</li>
							<li>
								<p v-if="item.uYzMonths!=0&&rqFn(setTime_yz(item.uYzStartDate,item.uYzMonths))" style="color: rgba(0, 120, 255, 1);">医嘱内容服务(截止{{setTime_yz(item.uYzStartDate,item.uYzMonths)}})</p>
								<p v-if="item.uWmpMonths!=0&&rqFn(setTime(item.uWmpStartDate,item.uWmpMonths))" style="color: rgba(0, 120, 255, 1);">科普内容服务(截止{{setTime(item.uWmpStartDate,item.uWmpMonths)}})</p>
								<p v-if="item.uYzMonths==0">医嘱内容服务</p>
								<p v-if="item.uWmpMonths==0">科普内容服务</p>
								<p v-if="item.uYzMonths!=0&&!rqFn(setTime_yz(item.uYzStartDate,item.uYzMonths))" style="color: red;">医嘱内容服务({{setTime_yz(item.uYzStartDate,item.uYzMonths)}}已过期)</p>
								<p v-if="item.uWmpMonths!=0&&!rqFn(setTime(item.uWmpStartDate,item.uWmpMonths))" style="color:red;">科普内容服务(截止{{setTime(item.uWmpStartDate,item.uWmpMonths)}})</p>
								
							</li>
							<li>
								<span :class="item.eSharedArticles==0?'red':''">{{item.eSharedArticles}}</span>
							</li>
							<li>
								<span :class="item.eSharedUsers==0?'red':''">{{item.eSharedUsers}}</span>
							</li>
							<li>
								<div>
									<button @click="yhglFn(item.id)">用户管理</button>
								</div>
							</li>
						</ul>
						<div class="list-more" v-show="deviceTip">
							<p>{{deviceTip}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="communicationPt" v-if="zsgltdBool">
			<div class="joinedComposition">
				<div class="header">
					<div class="fl">
						<i class="el-icon-arrow-left" @click="fanhuiFn()"></i>
						<span></span>
						<span>用户管理</span>
					</div>
				</div>
				<div class="content">
					<div class="fl">
						<div>
							<img :src="'https://api.bats-bio.com'+userJson.uAuthImg" alt="" />
						</div>
						<div class="table">
							<p>
								<span>姓名</span>
								<span>{{userJson.uName}}</span>
							</p>
							<p>
								<span>认证身份</span>
								<span>{{userJson.tName}}</span>
							</p>
							<p>
								<span>电话</span>
								<span>{{userJson.uTel}}</span>
							</p>
							<p>
								<span>邮箱</span>
								<span>{{userJson.uEmail}}</span>
							</p>
							<p>
								<span>登陆密码</span>
								<span>保密</span>
							</p>
							<p>
								<span>所在门诊</span>
								<span>保密</span>
							</p>
						</div>
					</div>
					<div class="">
						<p>权限管理</p>
						<div class="dpcPdm">
							<p @click="checkActiveFnDpc($event,userJson.uTel,userJson.id)">
								<i class="check" :class="[userJson.uIsAccDpc==1?'active':'']"></i> DPC
							</p>
							<p @click="checkActiveFnPdm($event,userJson.uTel,userJson.id)">
								<i class="check" :class="[userJson.uIsAccPdm==1?'active':'']"></i> PDM
							</p>
							<p @click="checkActiveFnCep($event,userJson.uTel,userJson.id)">
								<i class="check" :class="[userJson.uIsAccCep==1?'active':'']"></i> CEP
							</p>
						</div>
						<p>专家设置</p>
						<div class="dpcPdm">
							<p @click="checkActiveFnzj($event,userJson.uTel,userJson.id)">
								<i class="check" :class="[userJson.uIsExpert==1?'active':'']"></i> 专家
							</p>
							<div style="display: flex;align-items: center;">
								<p @click="checkActiveFnzj2($event,userJson.uTel,userJson.id)" class="fzj">
									<i class="check" :class="[userJson.uIsExpert==2?'active':'']"></i> 副专家
								</p>
								<div class="fzjdiv" >
									<!--v-show="userJson.uIsExpert==1"-->
									从属于
									<el-select v-model="value" placeholder="请选择">
									    <el-option
									      v-for="item in options"
									      :key="item.value"
									      :label="item.label"
									      :value="item.value">
									    </el-option>
									  </el-select>
								</div>
							</div>
						</div>
						<p>重置密码</p>
						<div class="iputPwd">
							<div>
								<el-input v-model="pwd" placeholder="请输入密码"></el-input>
							</div>
							<div>
								<button @click="user_resetpwdFn">确定重置</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="80%"
		  center>
		  <img style="text-align: center;" :src="DialogImg"/>
		  <span slot="footer" class="dialog-footer">
		    <!--<el-button @click="centerDialogVisible = false">取 消</el-button>-->
		    <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import {set_expert_status,user_count,users_list,user_resetpwd,users_row,checked_users, company_list, company_row, users_list_company,user_save, get_company, city_ztree, company_save, imgbase64upload, delete_from_company, set_dual_status } from '../../http/api.js'
	export default {
		components: {
			//		communicationptcom
		},
		data() {
			return {
				jsbq: ["种植修复", "嵌体修复", "隐适美", "全口义齿", "深覆颌", "对刃"],
				tableData: null,
				ddBool: true,
				ddBool1: true,
				tableList: [{
					tableName: '用户姓名',
				}, {
					tableName: '手机号',
				}, {
					tableName: '认证状态',
				}, {
					tableName: '拥有权限',
				}, {
					tableName: '医患通内容服务 ',
				},{
					tableName: '转发量',
				},{
					tableName: '授权粉丝',
				},{
					tableName: '用户操作',
				}],
				jggtable: false,
				input21: '',
				radio: '',
				value: '',
				options: [{
					lable: '1',
					value: '1'
				}],
				imageUrl: '',
				hznumBool: false,
				lrhzXxBool: false,
				DIYbqBool: false,
				datalist: [],
				devicePageSize: 10, //每页显示
				devicePageNum: 1, //当前页
				devicePageTotal: 0, //总条数
				devicePageTotalPages: 0, //总页数
				deviceListIsFinish: false, //是否加载完成
				deviceListIsLoad: false, //是否加载更多
				deviceListnodata: false, //是否有数据
				deviceTip: '',
				deviceList: [],
				deviceRow: {},
				ageMin: '',
				ageMax: '',
				yearList: [],
				yearVal: '',
				monthVal: '',
				sclyArr: [],
				yyxkImg: false,
				yyzzImg: false,
				mzglBool: true,
				cyglBool: false,
				xxgsVal: false,
				zsgltdBool: false,
				glList: [],
				drList: [],
				atList: [],
				addCyBool: false,
				tdlist: [],
				tel: '',
				xxgsVal: false,
				nameVal: '',
				zspwdVal: '1234abcd',
				value1: '',
				deleUser: [],
				sousuo: false,
				centerDialogVisible:false,
				DialogImg:'',
				userJson:{},
				daysflag:'',
				rz:'0,1,2,4,40',
				pwd:'',
				hzNum:0,
				ysNum:0,
				cjNum:0,
				gjNum:0,
				zlNum:0,
				gj1Num:0,
				zl1Num:0,
				kpgq:0,
				yzgq:0,
				rzxy_7:0,
				dcPageSize: 0, //每页显示
				dcPageNum: 1, //当前页
				dcDoctor:[]
			}
		},
		beforeMount() {
			this.getlist();
			this.user_countFn();
		},
		methods: {
			checkFn(num){
				if(num==1){
					return '高级认证'
				}else if(num==2){
					return '驳回认证'
				}else if(num==2){
					return '驳回认证'
				}else if(num==4){
					return '初级认证'
				}else if(num==40){
					return '正在审核  (初级升高级)'
				}
				
			},
			getlistdc() {
				let data = {
					page: this.dcPageNum,
					limit: this.dcPageSize,
					keyName: this.input21,
					days:this.daysflag,
      				user_type:'1,2,3',
      				rz: this.rz,
      				kpgq:this.kpgq,
      				yzgq:this.yzgq,
      				rzxy_7:this.rzxy_7
				}
				users_list(data).then(res => {
					this.dcDoctor=res.data;
					this.exportExcel();
				});
			},
			exportExcel() {
				var arr=[]
				for(var i=0;i<this.dcDoctor.length;i++){
					var json={
						index:i,
						date:this.dcDoctor[i].uName,
						tel:this.dcDoctor[i].uTel,
						num:this.checkFn(this.dcDoctor[i].uChecked),
						fxl:this.dcDoctor[i].eSharedArticles,
						fsl:this.dcDoctor[i].eSharedUsers
					}
					arr.push(json)
				}
				
				arr.push(json)
				if(this.dcDoctor.length==0){
					this.$message({
						message: '暂无数据导出',
						type: 'error',
						duration: 1000,
						onClose: () => {
						}
					})
				}else{
					 require.ensure([], () => {
					    const { export_json_to_excel } = require('../../../Excel/Export2Excel');//注意这个Export2Excel路径
					    const tHeader = [ "姓名","手机号","认证状态","分享量","授权粉丝"];   // 上面设置Excel的表格第一行的标题
					    const filterVal = ['date','tel', 'num','fxl','fsl']; // 上面的index、nickName、name是tableData里对象的属性key值
					    const list = arr;  //把要导出的数据tableData存到list
					    const data = this.formatJson(filterVal, list);
					    export_json_to_excel(tHeader, data, '医生列表');//最后一个是表名字
					  })
					 this.$message({
						message: '已导出',
						type: 'success',
						duration: 1000,
						onClose: () => {
						}
					})
					
				}
			},
			formatJson(filterVal, jsonData) {
			  return jsonData.map(v => filterVal.map(j => v[j]))
			},
			user_countFn(){
				user_count().then(res=>{
					for(var i=0;i<res.list.length;i++){
						if(res.list[i].id==8) this.hzNum=res.list[i].regsum;
						if(res.list[i].id==2) this.ysNum=res.list[i].regsum;
						if(res.list[i].id==3) this.zlNum=res.list[i].regsum;
						if(res.list[i].id==2) this.gjNum=res.list[i].gjtj;
						if(res.list[i].id==2) this.cjNum=res.list[i].pttj;
						if(res.list[i].id==3) this.gj1Num=res.list[i].gjtj;
						if(res.list[i].id==3) this.cj1Num=res.list[i].pttj;
					}
				})
			},
			yhglFn(id){
				var data={
					id:id
				}
				users_row(data).then(res=>{
					if(res.result==1){
						this.userJson=res.row;
						this.zsgltdBool=true;
					}
				})
			},
			Uchecked(val){
				if(val==1){
					return '高级认证'
				}else if(val==4){
					return '初级认证'
				}
			},
			user_resetpwdFn(){
				if(this.pwd!=''&&this.pwd.length>6){
					var data={
						id:this.userJson.id,
						uTel:this.userJson.uTel,
						uPwd:this.pwd
					}
					user_resetpwd(data).then(res=>{
						this.$message({
							message: res.msg,
							type: 'success',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				}else{
					this.$message({
						message: '密码格式不正确',
						type: 'error',
						duration: 1000,
						onClose: () => {
						}
					})
				}
			},
			restTime(val,id){
				var setTime = new Date(val);//格式化认证日期
				var nowTime =  new Date();//获取当前日期
				var restSec = nowTime.getTime()-setTime.getTime();
				var day = parseInt(restSec/(60*60*24*1000));//离认证日期多少天
				if(30-day<=0){
					this.checkActiveFn1(id);	
				}
				return 30-day;
			},
			checkActiveFn1(id){
				var data = {
					id: id,
					uIsAccDpc: 0,
					uIsAccPdm: 0
				}
				user_save(data).then(res => {
					
				})
			},
			yearFn() {
				for(var i = 1910; i <= new Date().getFullYear(); i++) {
					//					addOption(birth_year, i, i - 1909);
					var data = {
						age: i
					}
					this.yearList.unshift(data);
				}
			},
			arrFn(str) {
				var arr = []
				arr = (str || "").split(',');
				return arr[1] + '/' + arr[2]
			},
			getlist() {
				let data = {
					page: this.devicePageNum,
					limit: this.devicePageSize,
					keyName: this.input21,
					days:this.daysflag,
      				user_type:'1,2,3',
      				rz: this.rz,
      				kpgq:this.kpgq,
      				yzgq:this.yzgq,
      				rzxy_7:this.rzxy_7
				}
				users_list(data).then(res => {
					if(res.result == 0) {
						this.devicePageTotal = res.total;
						//需要加当前页和每页显示
						//			        this.devicePageSize = res.pageSize;

						//			        this.devicePageNum = res.pageNum;
						this.devicePageTotalPages = res.count;
						this.dcPageSize = res.count;
						if(res.data == '') {
							this.deviceListnodata = true;
							this.deviceListIsLoad = false;
							this.deviceListIsFinish = true;
							this.devicePageNum = 1;
							this.deviceTip = "暂无数据";
							return false;
						} else {
							if(this.devicePageTotalPages < this.devicePageSize) {
								this.deviceListnodata = true;
								this.deviceListIsLoad = false;
								this.deviceListIsFinish = true;
								this.devicePageNum = 1;
								this.deviceTip = "暂无数据";
								//					            return false;  	
							} else {
								this.deviceListIsLoad = true;
								this.deviceListIsFinish = false;
								this.devicePageNum++;
								this.deviceTip = "正在加载中~";
							}
						}
						this.datalist = this.datalist.concat(res.data);
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
							duration: 1000,
							onClose: () => {}
						})
						this.deviceListIsLoad = false;
						this.deviceListIsFinish = true;
						this.devicePageNum = 1;
						this.deviceTip = "数据加载失败~";
					}
				});
			},
			fanhuiFn() {
				this.zsgltdBool = false;
			},
			company_rowFn(id) {
				this.zsgltdBool = true;
				var data = {
					id: id
				}
				company_row(data).then(res => {
					if(res.result == 1) {
						this.companysrow = res.row;
						this.nameVal = this.companysrow.cName;
						this.lxtel = this.companysrow.cTel;
						this.ylImg = this.companysrow.cImgA;
						this.yyImg = this.companysrow.cImgB;
						this.vxVal = this.companysrow.cWxImg;
						this.gfwzVal = this.companysrow.cUrl;
						this.addressVal = this.companysrow.cAddr;
						//						this.zspwdVal=this.companysrow.lUserPwd;
						this.chengshiFn()
						this.sheng = this.companysrow.cProvinceID;
						this.shiFn()
						this.shi = this.companysrow.cCityID;
						this.minname = this.companysrow.cNickName
					}
				})
				var data1 = {
					cpy_id: id,
					user_type:'1,2,3',
					pageSize:100
					//					rz:2,
				}
				this.glList = [];
				this.tdlist=[];
				users_list_company(data1).then(res => {
					this.glList =  res.data;
					for(var i=0;i<this.glList.length;i++){
						this.tdlist.unshift(this.glList[i]);
						this.tdlist.sort(this.up);
					}
				})

			},
			up(a,b){
				return a.uTypeID-b.uTypeID
			},
			rz1(){
  				if(this.rz=='0,1,2,4,40'){
  					this.sousuoFn();
  				}else{
  					this.rz='0,1,2,4,40';
  					this.sousuoFn();
  				}
  			},
  			rz2(){
  				if(this.rz=='4'){
  					this.rz='0,1,2,4,40';
  					this.sousuoFn();
  				}else{
  					this.rz='4';
  					this.sousuoFn();
  				}
  			},
  			rz3(){
  				if(this.rz=='1'){
  					this.rz='0,1,2,4,40';
  					this.sousuoFn();
  				}else{
  					this.rz='1';
  					this.sousuoFn();
  				}
  			},
  			rz4(){
  				if(this.rz=='2'){
  					this.rz='0,1,2,4,40';
  					this.sousuoFn();
  				}else{
  					this.rz='2';
  					this.sousuoFn();
  				}
  			},
  			rz5(){
  				if(this.rz=='40'){
  					this.rz='0,1,2,4,40';
  					this.sousuoFn();
  				}else{
  					this.rz='40';
  					this.sousuoFn();
  				}
  			},
  			yzgqFn(){
  				if(this.yzgq==1){
  					this.yzgq=0;
  					this.sousuoFn();
  				}else{
  					this.yzgq=1;
  					this.sousuoFn();
  				}
  			},
  			kpgqFn(){
  				if(this.kpgq==1){
  					this.kpgq=0;
  					this.sousuoFn();
  				}else{
  					this.kpgq=1;
  					this.sousuoFn();
  				}
  			},
  			rzxy_7Fn(){
  				if(this.rzxy_7==1){
  					this.rzxy_7=0;
  					this.sousuoFn();
  				}else{
  					this.rzxy_7=1;
  					this.sousuoFn();
  				}
  			},
			daysflagqbs(){
  				if(this.daysflag==''){
  					this.daysflag='';
  					this.sousuoFn();
  					
  				}else{
  					this.daysflag='';
  					this.keyName='';
  					this.sousuoFn();
  				}
  			},
  			daysflagdays(){
  				if(this.daysflag==1){
  					this.daysflag='';
  					this.sousuoFn();
  					
  				}else{
  					this.daysflag=1;
  					this.keyName='';
  					this.sousuoFn();
  				}
  			},
  			daysflagweekdays(){
  				if(this.daysflag==7){
  					this.daysflag='';
  					this.sousuoFn();
  				}else{
  					this.daysflag=7;
  					this.keyName='';
  					this.sousuoFn();
  				}
  			},
  			changeType() {
		        if (this.eye) {
			        this.eye = false
			        this.pwdType = 'password'
			      } else {
			        this.eye = true
			        this.pwdType = 'text'
			      }
//				event.stopPropagation();
		     },
  			daysflagmonths(){
  				if(this.daysflag==30){
  					this.daysflag='';
  					this.sousuoFn();
  				}else{
  					this.daysflag=30;
  					this.keyName='';
  					this.sousuoFn();
  				}
  			},
  			daysflagyears(){
  				if(this.daysflag==365){
  					this.daysflag='';
  					this.sousuoFn();
  				}else{
  					this.daysflag=365;
  					this.keyName='';
  					this.sousuoFn();
  				}
  			},
  			sousuoFn(){
				this.datalist=[];
				this.devicePageSize= 15;//每页显示
		   		this.devicePageNum= 1; //当前页
		   		this.devicePageTotal= 0; //总条数
		   		this.devicePageTotalPages= 0; //总页数
		    	this.deviceListIsFinish= false; //是否加载完成
		    	this.deviceListIsLoad=false; //是否加载更多
		    	this.deviceListnodata= false; //是否有数据
				this.getlist();
			},
			jiansuoFn() {
				this.sousuo = true;
				this.datalist = [];
				this.deviceListnodata = true;
				this.deviceListIsLoad = false;
				this.deviceListIsFinish = true;
				this.devicePageNum = 1;
				this.getlist()
				this.sousuo = false;

			},
			xgxxFn() {
				var data = {
					id: this.companysrow.id,
					cTypeID: '1',
					cName: this.nameVal,
					cTel: this.lxtel,
					cAddr: this.addressVal,
					cProvinceID: this.sheng,
					cCityID: this.shi,
					cLatLng: '',
					cIsShowSlideSelf: '1',
					cUrl: this.gfwzVal,
					cWxImg: this.vxVal,
					cImgA: this.ylImg,
					cImgB: this.yyImg,
					cRoute: this.addressVal,
					lUserPwd: this.zspwdVal,
					cNickName: this.minname,
					cPerson:this.companysrow.cPerson
				}
				company_save(data).then(res => {
					var that = this;
					if(res.result == 1) {
						that.$message({
							message: '修改成功',
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.xxgsVal = false;
							}
						})
					} else {
						that.$message({
							message: res.msg,
							type: 'error',
							duration: 1000,
							onClose: () => {}
						})
					}
				})
			},
			getSex(sex) {
				return sex == 1 ? '男' : '女';
			},
			scrollEvent(e) {
				if(e instanceof Event) {
					let el = e.target;
					let scrollTop = el.scrollTop;
					// 获取可视区的高度
					let clientHeight = el.clientHeight;
					// 获取滚动条的总高度
					let scrollHeight = el.scrollHeight;
					let height = 140; //一格表格的高
					if(scrollTop + clientHeight >= scrollHeight && this.deviceListIsLoad && !this.deviceListIsFinish) {
						this.deviceListIsLoad = true;
						//			        console.log("到底了");
						var timer = setTimeout(() => {
							this.getlist();
							clearTimeout(timer)
						}, 1000);
					}
				}
			},
			Sfqmonthdaydiv(table, event) {
				var el = event.target
				$(el).addClass('router-link-active');
				$(el).siblings().removeClass('router-link-active');
				$(el).parent().parent().siblings().children().children().removeClass('router-link-active');
				this.$router.push({
					path: '/indexDr/DrtechnologyCommunication/table4',
					query: {
						name: 1
					}
				})
			},
			yyxkImgFn(){
				if(this.companysrow.cImgA){
					this.centerDialogVisible=true;
					this.DialogImg=this.companysrow.cImgA;
				}else{
					this.$message({
		                message:"该诊所未上传营业许可证",
		                type: 'info',
		                duration:1000,
		                onClose:()=>{
		                	that.xxgsVal=false;
		                	that.xiugaiqueding=false;
		                	that.companys_rowFn();
		         		}
					})
				}
			},
			yyzzImgFn(){
				if(this.companysrow.cImgA){
					this.centerDialogVisible=true;
					this.DialogImg=this.companysrow.cImgB;
				}else{
					this.$message({
		                message:"该诊所未上传营业执照",
		                type: 'info',
		                duration:1000,
		                onClose:()=>{
		                	that.xxgsVal=false;
		                	that.xiugaiqueding=false;
		                	that.companys_rowFn();
		         		}
					})
				}
			},
			imgCloseFn() {
				this.yyzzImg = false;
				this.yyxkImg = false;
			},
			upDrtechnologyCommunication() {

			},
			hznumFn() {
				this.hznumBool = true;
			},
			hidehznumFn() {
				this.hznumBool = false;

			},
			DIYbqFn() {
				this.DIYbqBool = true;
			},
			hideDIYbqFn() {
				this.DIYbqBool = false;
			},
			taggleFn(str, event) {
				var el = event.target;
				if(this.jub(str, this.sclyArr)) {
					$(el).removeClass('active');
					this.sclyArr.splice(this.sclyArr.indexOf(str), 1)
					var data = {
						uGoods: '传统修复'
					}
					users_save(data).then(res => {
						if(res.result == 1) {
							this.$message({
								message: '提交成功',
								type: 'success',
								duration: 1000,
								onClose: () => {}
							})
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
								duration: 1000,
								onClose: () => {}
							})
						}
					})
				} else {
					$(el).addClass('active')
					this.sclyArr.push(str)
					var data = {
						uGoods: '传统修复'
					}
					users_save(data).then(res => {
						if(res.result == 1) {
							this.$message({
								message: '提交成功',
								type: 'success',
								duration: 1000,
								onClose: () => {}
							})
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
								duration: 1000,
								onClose: () => {}
							})
						}
					})
				}
			},
			tabClick(str, el) {
				var el = event.currentTarget;
				$(el).addClass('active').siblings().removeClass('active')
				if(str == '1') {
					this.mzglBool = true;
					this.cyglBool = false;
				} else if(str == '2') {
					this.cyglBool = true;
					this.mzglBool = false;
					this.xxgsVal = false
				}
			},
			jub(num, arr) {
				for(var i = 0; i < arr.length; i++) {
					if(num == arr[i]) {
						return true;
					}
				}
			},
			yqgrFn() {
				var data = {
					cpy_id:this.companysrow.id,
					tel: this.tel
				}
				get_company(data).then(res => {
					if(res.result == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.addCyBool=false;
							}
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'info',
							duration: 1000,
							onClose: () => {
								this.addCyBool=false;
							}
						})
					}
				})
			},
			handleAvatarSuccess(res, file) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.2)'
				});
				let that = this;
				var reader = new FileReader();
				console.log(file)
				reader.readAsDataURL(file.raw);
				var img = new Image;
				var a = 0;
				var name = file.name;
				reader.onload = function() {
					let base64Str = reader.result.split(',')[1];
	                img.src = this.result;
					this.dataobj = {
						img_str: img.src,
						dir: 'upload/file',
						file_name: name

					}
					imgbase64upload(this.dataobj).then(res => {
						if(res.result == 1) {
							var image1 = res.img;
							that.$message({
								message: '上传成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.ylImg = image1;
								}
							})
						} else {
							that.$message({
								message: '图片加载失败',
								type: 'error',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.BATSimageBannercenter = '';
								}
							})
						}
					})
				};
				reader.onerror = function(error) {
					loading.close();
				};
			},
			 beforeAvatarUpload(file){
	    	 	if (!/^image\/(jpeg|png)$/.test(file.type)) {
			          this.$confirm('上传图片暂时只支持PNG/JPG格式', '提示', {
			            confirmButtonText: '确定',
			            type: 'error' ,
			            callback: action => {
			
			            }
			          })
			    }
//			      return isJPG;
			},
			handleAvatarSuccess1(res, file) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.2)'
				});
				let that = this;
				var reader = new FileReader();
				reader.readAsDataURL(file.raw);
				var img = new Image;
				var a = 0;
				var name = file.name
				reader.onload = function() {
					let base64Str = reader.result.split(',')[1];
	                img.src = this.result;
					this.dataobj = {
						img_str: img.src,
						dir: 'upload/file',
						file_name: name
					}
					imgbase64upload(this.dataobj).then(res => {
						if(res.result == 1) {
							var image1 = res.img;
							that.$message({
								message: '上传成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.yyImg = image1;
								}
							})
						} else {
							that.$message({
								message: '图片加载失败',
								type: 'error',
								duration: 1000,
								onClose: () => {
									loading.close();
									that.BATSimageBannercenter = '';
								}
							})
						}
					})
				};
				reader.onerror = function(error) {
					loading.close();
				};
			},
			checkActiveFn(event, tel, id) {
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						uid: id,
						zt: 0
					}
					set_dual_status(data).then(res => {
						if(res.result==1){
							this.$message({
								message: '设置成功',
								type: 'error',
								duration: 1000,
								onClose: () => {
								}
							})
						}
					})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						uid: id,
						zt: 1
					}
					set_dual_status(data).then(res => {})
				}
			},
			checkActiveFnDpc(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						id: id,
						uIsAccDpc: 0
					}
					user_save(data).then(res => {
						this.$message({
							message: '已取消该用户DPC权限',
							type: 'info',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						id: id,
						uIsAccDpc: 1
					}
					user_save(data).then(res => {
						this.$message({
							message: '已设置该用户DPC权限',
							type: 'success',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				}
			},
			checkActiveFnPdm(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						id: id,
						uIsAccPdm: 0
					}
					user_save(data).then(res => {
						this.$message({
							message: '已取消该用户PDM权限',
							type: 'info',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						id: id,
						uIsAccPdm: 1
					}
					user_save(data).then(res => {
						this.$message({
							message: '已设置该用户PDM权限',
							type: 'success',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				}
			},
			setTime(val,position){
			    if (val != null && val != '') {
			      var list = val.split('-');
			      var year = list[0];
			      var month = list[1];
			      var day = list[2];
			      if (position == 12) {
			        year++;
			      } else if (position == 3) {
			        for (let i = 0; i < 3; i++) {
			          month++;
			        }
			        if (month < 10) {
			          month = '0' + month;
			        } else if (month > 12) {
			          var po = month - 12;
			          year++;
			          month = '0' + po;
			        }
			      } else if (position == 1) {
			        if (month < 12) {
			          month++;
			          if (month < 10) {
			            month = '0' + month;
			          }
			        } else {
			          year++;
			          month = '01';
			        }
			      } else {
			        for (let i = 0; i < position; i++) {
			          month++;
			        }
			        if (month < 10) {
			          month = '0' + month;
			        } else if (month > 12) {
			          var po = month - 12;
			          year++;
			          month = '0' + po;
			        }
			      }
			
			      return year + '-' + month + '-' + day;
			    } else {
			      return val;
			    }
			  },
		    setTime_yz (val,s) {
			    var _this = this;
			    var list = val.split('-');
			    var year = list[0];
			    var month = list[1];
			    var day = list[2];
			    	year = Number(year)+Number(s/12);
			    console.log(year)
			    return year + '-' + month + '-' + day;
			  },
			checkActiveFnCep(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						id: id,
						uIsAccCep: 0
					}
					user_save(data).then(res => {
						this.$message({
							message: '已取消该用户CEP权限',
							type: 'info',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						id: id,
						uIsAccCep: 1
					}
					user_save(data).then(res => {
						this.$message({
							message: '已设置该用户CEP权限',
							type: 'success',
							duration: 1000,
							onClose: () => {

							}
						})
					})
				}
			},
			checkActiveFnzj(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						uid: id,
						uIsExpert: 0
					}
					set_expert_status(data).then(res => {
						this.$message({
							message: '已取消该用户专家权限',
							type: 'info',
							duration: 1000,
							onClose: () => {
								this.yhglFn(id)
								
							}
						})
					})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						uid: id,
						uIsExpert: 1
					}
					set_expert_status(data).then(res => {
						this.$message({
							message: '已设置该用户专家权限',
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.yhglFn(id)
								
							}
						})
					})
				}
			},
			checkActiveFnzj2(event, tel, id){
				var el = event.currentTarget;
				if($(el).children('.check').is('.active')) {
					$(el).children('.check').removeClass('active');
					var data = {
						uid: id,
						uIsExpert: 0
					}
					set_expert_status(data).then(res => {
						this.$message({
							message: '已取消该用户专家权限',
							type: 'info',
							duration: 1000,
							onClose: () => {
							}
						})
					})
				} else {
					$(el).children('.check').addClass('active');
					var data = {
						uid: id,
						uIsExpert: 2
					}
					set_expert_status(data).then(res => {
						this.$message({
							message: '已设置该用户专家权限',
							type: 'success',
							duration: 1000,
							onClose: () => {
								
							}
						})
					})
				}
			},
			 rqFn(date){
			 	if(date!=null){
			 		var normalizeDate = date.split("-");
			          var Month = new Date().getMonth() + 1;
			          var year = new Date().getFullYear();
			          var day = new Date().getDate();
			          if (normalizeDate[0] < year) {
			              return false
			          } else if(normalizeDate[0] == year){
			              if (normalizeDate[1] < Month) {
			                  console.log(normalizeDate[1]< Month)
			                  return false;
			              }else if(normalizeDate[1] == Month){
			                  if (normalizeDate[2] < day) {
			                      return false;
			                  }else {
			                      return true;
			                  };
			              }else {
			                  return true;
			              };
			          } else{
			              return true;
			          };
			 	}
		          
		  
		    },
		},
		watch: {
			$route(to, from) {
				if(this.$route.query.hide == 1) {
					$('.communicationPt').hide();
				}
			}
		},
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.communication {
		font-size: 12px;
		width: 100%;
		float: right;
		height: 788px;
		position: relative;
		/*cursor: pointer;*/
		overflow: hidden;
		background: #FFFFFF;
	}
	
	.communicationPt {
		font-size: 12px;
		width: 100%;
		float: right;
		height: 788px;
		position: relative;
		overflow: hidden;
		/*background: #FFFFFF;*/
	}
	
	.communicationPt {
		z-index: 998;
		position: absolute;
	}
	
	.Atlist {
		width: 302px;
		height: 100%;
	}
	
	.Attable {
		margin-left: 302px;
		height: 100%;
		/*background: #7797B2;*/
	}
	
	.commtitle {
		height: 70px;
		width: 100%;
		line-height: 70px;
		font-weight: 600;
		font-size: 18px;
		color: #9B9B9B;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
	}
	
	.iconImg {
		display: block;
		width: 22px;
		height: 22px;
		float: left;
		margin-top: 25px;
		margin-right: 11px;
		margin-left: 20px;
		color: #9B9B9B;
	}
	
	.c1 {
		background: url(../../../assets/image/c1.png) no-repeat center center;
	}
	
	.addNewAt {
		width: 302px;
		height: 40px;
		background: rgba(104, 107, 117, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		color: #FFFFFF;
	}
	
	.Atlistxiangqing {}
	.red{
		color: red;
	}
	.Attableheader {
		height: 70px;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
		;
	}
	
	.retrievalipt {
		margin-top: 15px;
		width: 263px;
		margin-left: 20px;
		padding-bottom: 20px;
		border-bottom: 2px solid #F1F1F1;
	}
	
	.datard {
		margin-top: 5px;
		overflow: hidden;
	}
	
	.datard span {
		display: block;
		float: left;
	}
	
	.datard>span:nth-child(1) {
		margin-right: 5px !important;
		width: 93px !important;
	}
	
	.datard>span:nth-child(2),
	.datard>span:nth-child(3) {
		width: 72px;
		margin-right: 5px;
	}
	
	.Attablelist {
		height: 100%;
		background: #F5F5F5;
	}
	
	.Attablelistbox {
		width: 257px;
		height: 266px;
		padding-top: 14px;
		float: left;
		/*margin-right: 3px;*/
		border-right: 3px solid #CCCCCC;
		/*background:rgba(155,155,155,1);*/
		/*box-shadow:0px 0px 2px 0px rgba(119,151,178,0.16);*/
	}
	
	.qhtable {
		width: 48px;
		height: 48px;
		background: rgba(0, 120, 255, 1);
		border-radius: 50%;
		position: absolute;
		bottom: 45px;
		right: 30px;
	}
	
	.jgghzlist {
		height: 789px;
	}
	
	.tablehzlist {
		/*width: 776px;*/
		height: 789px;
	}
	
	.retrievalspan {
		/*margin-top:10px ;*/
		overflow: hidden;
	}
	
	.zdyspan {
		/*border-left:1px !important;*/
		border: 1px solid rgba(215, 215, 215, 1) !important;
	}
	
	.zdyspan .el-icon-edit-outline {
		color: #0073FF;
	}
	
	.retrievalspan span {
		display: block;
		margin-top: 10px;
		height: 20px;
		padding-left: 10px;
		padding-right: 10px;
		margin-right: 10px;
		/*margin-bottom: 5px;*/
		line-height: 20px;
		color: rgba(155, 155, 155, 1);
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(215, 215, 215, 1);
		border-left: 5px solid #636670;
		border-radius: 3px;
		text-align: left;
		float: left;
		cursor: pointer;
	}
	
	.retrievalspan span.active {
		font-weight: 600;
		color: rgba(0, 120, 255, 1);
		border-left-color: rgba(0, 120, 255, 1);
	}
	
	.dq>div>p {
		padding-bottom: 5px;
		padding-left: 5px;
	}
	
	.selectDiv,
	.selectDiv1 {
		/*margin-right: 6px;*/
		margin-bottom: 10px;
	}
	
	.selectDiv1 {
		margin-left: 6px;
	}
	
	.selectDiv>div {
		width: 113px;
		float: left;
		margin-right: 5px;
	}
	
	.selectDiv1>div {
		width: 123px;
		float: left;
		margin-right: 5px;
	}
	
	.selectDiv>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
	}
	
	.selectDiv1>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 40px;
	}
	
	.dqBox {
		margin-top: 20px;
		margin-left: 20px;
		overflow: hidden;
	}
	
	.dqBox>p {
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(0, 0, 0, 1);
		line-height: 22px;
		margin-bottom: 5px;
	}
	
	.dqBox>div.boxbtn {
		width: 263px;
		height: 40px;
	}
	
	.dqBox>div.boxbtn:hover button {
		border: 2px solid yellow;
	}
	
	.dqBox>div.boxbtn>button {
		width: 263px;
		height: 40px;
		border-radius: 6px;
		background: rgba(0, 120, 255, 1);
		color: #FFFFFF;
		font-size: 16px;
	}
	.btnjj{
		margin-top: 250px;
	}
	/*。。。。。。。。。。。。。*/
	
	.tableHeader {
		margin-top: 40px;
		width: 100%;
		height: 30px;
		border-bottom: 2px solid rgba(119, 151, 178, 0.16);
		;
	}
	
	.tablecontent {
		margin-top: 0;
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #F5F5F5;
	}
	
	.tablecontent::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FFFFFF;
	}
	
	.tablecontent::after {
		content: "";
		display: block;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FFFFFF;
	}
	
	.tableHeader li {
		height: 30px;
	}
	
	.tableHeader li,
	.tablecontent li {
		float: left;
		text-align: center;
		font-size: 12px;
		color: #9B9B9B;
	}
	
	.tablecontent li {
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		z-index: 3;
		overflow: hidden;
	}
	
	.tablecontent li::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;
		/*px*/
	}
	
	.tablecontent li:nth-child(1)::before {
		border: none;
	}
	
	.tablecontent li:nth-child(1) {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontent li:nth-child(1)>p {
		margin: 0 10px;
		word-wrap: break-word;
		word-break: break-all
	}
	
	.tablecontent li:nth-child(2)::before {}
	
	.tableHeader li:nth-child(1) {
		width: 15%;
	}
	
	.tableHeader li:nth-child(2) {
		width: 14%;
	}
	
	.tableHeader li:nth-child(4) {
		width: 10%;
	}
	.tableHeader li:nth-child(4).tableA{
		width: 10%;
		display: flex;
		flex-wrap: wrap;
 		align-content:center;
 		align-items: center;
 		justify-content: center;
	}
	.tableHeader li:nth-child(4)>P{
		height: 15px;
		line-height: 15px !important;
		width: 100%;
		margin: 3px;
	}
	.tableHeader li:nth-child(3) {
		width: 11%;
	}
	
	.tablecontent li:nth-child(3) {
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontent li:nth-child(3)>p {
		margin: 0 10px;
		word-wrap: break-word;
		word-break: break-all
	}
	
	.tableHeader li:nth-child(5) {
		width: 15%;
	}
	.tablecontent li:nth-child(5){
		display: flex;
		flex-wrap: wrap;
 		align-content:center;
 		align-items: center;
 		justify-content: center;
	}
	.tablecontent li:nth-child(5)>p{
		height: 15px;
		line-height: 15px !important;
		width: 100%;
		margin: 3px;
	}
	.tableHeader li:nth-child(6) {
		width: 10%;
	}
	.tableHeader li:nth-child(7) {
		width: 9%;
	}
	.tableHeader li:nth-child(8) {
		width: 15%;
		
	}
	
	.tableHeader li:nth-child(8)>div {
		width: 126px;
		height: 30px;
		margin: 54px auto;		
	}
	
	.tableHeader li:nth-child(8)>div:hover button {
		border: 2px solid yellow;
	}
	
	.tableHeader li:nth-child(8)>div>button {
		width: 126px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		float: left;
	}
	
	.tabletd {
		/*position: absolute;
		top: 30px;
		left: 0;*/
		overflow: auto;
		background: #F5F5F5;
		width: 100%;
		height: 721px;
	}
	.tabletd::-webkit-scrollbar { width: 0 !important }
	.tabletd { overflow: -moz-scrollbars-none; }
	.tabletd {
	   scrollbar-width: none;
	}
	.gjretrieval>div {
		margin: 20px 0;
		overflow: hidden;
		line-height: 20px;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		cursor: pointer;
	}
	
	.gjretrieval>div>div:nth-child(2)>span:nth-child(1) {}
	
	.gjretrieval>div>span:nth-child(2) {
		margin-right: 30px;
	}
	
	.gjretrieval>div>span>i {
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: url(../../../assets/image/圈未选中.png) no-repeat center center;
		background-size: 100%;
		float: left;
		margin-right: 10px;
	}
	
	.gjretrieval>div>span>i.active {
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
	}
	
	.gjretrieval>p>i {
		margin-left: 14px;
		font-weight: 600;
		transition: .3S all;
	}
	
	.gjretrieval>p>i.active {
		transition: .3S all;
		transform: rotateZ(90deg);
	}
	
	.gjretrieval div>span:nth-child(1) {
		font-size: 14px;
		margin-right: 10px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
	}
	
	.list-more {
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}
	
	.notJoined {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.notJoined>div {
		width: 299px;
		height: 274px;
		padding: 0 40px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.13);
		border-radius: 8px;
		margin-top: -100px;
	}
	
	.notJoined>div>div:nth-child(2) {
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
		margin-bottom: 60px;
		margin-top: 90px;
	}
	
	.notJoined>div:nth-child(1)>div:nth-child(3)>button {
		width: 299px;
		height: 35px;
		background: rgba(176, 176, 176, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
	}
	
	.notJoined>div:nth-child(2)>div:nth-child(3)>button {
		width: 299px;
		height: 35px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
	}
	
	.myJoined,
	.joinedComposition {
		width: 100%;
		height: 789px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 2px 2px 2px 0px rgba(119, 151, 178, 0.16);
	}
	
	.header {
		width: 100%;
		height: 68px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 2px 0px rgba(119, 151, 178, 0.16);
		z-index: 90;
		position: relative;
	}
	
	.header>div:nth-child(1) {
		width: 255px;
		height: 100%;
		float: left;
		position: absolute;
	}
	
	.header>div:nth-child(1)>i {
		font-size: 18px;
		margin-left: 23px;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.header>div:nth-child(1)>span:nth-child(2) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(155, 155, 155, 1);
		line-height: 68px;
	}
	
	.header>div:nth-child(1)>span:nth-child(3) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(74, 74, 74, 1);
		line-height: 68px;
	}
	
	.header>div:nth-child(2) {
		margin-left: 130px;
		height: 100%;
	}
	
	.header>div:nth-child(2)>div:nth-child(1) {
		width: 100%;
	}
	
	.content {
		width: 100%;
		height: 719px;
		background: RGBA(245, 245, 245, 1);
		/*overflow: hidden;*/
		/*padding-left: 5px;*/
		/*display: flex;
		justify-content:space-around;*/
		/*align-items: center;*/
		/*box-shadow:0px 0px 2px 0px rgba(119,151,178,0.16);*/
	}
	
	.joinedList>div {
		width: 216px;
		height: 118px;
		background: rgba(255, 255, 255, .7);
		border-radius: 3px;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(74, 74, 74, 1);
		text-align: center;
		line-height: 118px;
		margin: 10px 0;
	}
	
	.content>div.fl {
		width: 300px;
		height: 720px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 2px 0px 4px 0px rgba(155, 155, 155, 0.23);
		text-align: center;
	}
	.content>div.fl>div>img{
		width: 200px;
		height: 250px;
		background: #F0F0F0;
		margin-top: 30px;
	}
	.table{
		width: 200px;
		margin: 0 auto;
	}
	.table>p{
		height: 20px;
		text-align: left;
		overflow: hidden;
		margin-top: 10px;
	}
	.table>p>span{
		display: block;
		float: left;
		width: 100px;
	}
	.table>p{
		font-size: 15px;
		color: #000000;
	}
	.content>div:nth-child(2) {
		/*width: calc(100%-205px);*/
		/*width: 76%;*/
		/*margin-top: 2px;*/
		margin-left: 300px;
		overflow: hidden;
		/*box-shadow:0px 0px 4px 0px rgba(0,0,0,0.13);*/
		/*float: left;*/
		/*margin-left: ;*/
	}
	.content>div:nth-child(2)>p{
		margin: 30px;
		font-size: 20px;
		font-weight: bold;
	}
	.modelcontent {
		width: 100%;
		height: 718px;
		background: #F5F5F5;
	}
	
	.modelcontent>div:nth-child(1) {
		width: 100%;
		height: 142px;
	}
	
	.modelcontent>div:nth-child(2) {
		width: 100%;
		height: 575px;
	}
	
	.modelcontent>div:nth-child(1)>div:nth-child(1) {
		width: 100%;
		border-right: none;
	}
	
	.modelcontent>div>div:nth-child(2) {
		/*width: calc(100%-75px);*/
		/*margin-left: 75px;*/
	}
	
	.modelcontent>div:nth-child(1)>div:nth-child(1) {
		border-bottom: 3px solid #FFFFFF;
		height: 139px;
	}
	
	.userSet {
		width: 100%;
		height: 142px;
		border-bottom: 3px solid #FFFFFF;
		overflow: hidden;
	}
	
	.userSet>div {
		width: 100%;
		height: 117px;
		background: #FFFFFF;
		margin-top: 14px;
	}
	
	.userSet>div>div:nth-child(1)>div {
		margin-top: 41px;
		margin-right: 15px;
		overflow: hidden;
	}
	
	.userSet>div>div:nth-child(2)>div {
		margin-right: 69px;
		margin-top: 18px;
		margin-bottom: 13px;
	}
	
	.userSet>div>div:nth-child(2)>div>button {}
	
	.userSet>div>div:nth-child(1)>div:nth-child(1) {
		margin-left: 83px;
	}
	
	.userSet>div>div>div {
		width: 100px;
		height: 30px;
	}
	
	.userSet>div>div>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.userSet>div>div>div>button {
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	
	.modelcontent>div>div:nth-child(1)>p {
		font-size: 16px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		width: 32px;
		line-height: 20px;
		color: rgba(74, 74, 74, 1);
		margin-top: 3px;
	}
	
	.modelcontent>div:nth-child(1)>div:nth-child(2) {
		border-bottom: 3px solid #FFFFFF;
		height: 139px;
		/*width: 90.5%;*/
		/*width: 100%;*/
		margin-left: 75px;
	}
	
	.modelcontent>div:nth-child(2)>div:nth-child(2) {
		height: 575px;
	}
	
	.tdlist{
		height: 100%;
		overflow-y:scroll ;
	}
	.tdlist>div{
		display: flex;
		min-height:142px;
	}
	.tdlist>div:nth-child(2){
		/*margin-left: 63px;*/
	}
	.tdlist>div>div:nth-child(1){
		width:60px;
		height: auto;
		border-right: 3px solid #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.tdlist>div>div{
		width: 100%;
		border-bottom: 3px solid #FFFFFF;
		overflow: hidden;
		text-align: center;
	}
	.tdlist>div>div>p{
		font-size:12px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:23px;
	}
	.zl>p:nth-child(1){
		writing-mode: tb-rl;
	}
	
	.tablelist {
		position: relative;
		height: 142px;
		width: 100%;
		/*overflow: hidden;*/
	}
	
	.tableList {
		position: relative;
		height: 100%;
		overflow: hidden;
	}
	
	.tableList>li {
		/*height: 100%;*/
		float: left;
		text-align: center;
		margin-top: 50px;
		color: rgba(155, 155, 155, 1);
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 600;
	}
	
	.tablelist>li {
		height: 142px;
		float: left;
		text-align: center;
		position: relative;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 600;
		color: rgba(155, 155, 155, 1);
		z-index: 3;
	}
	
	.tablelist>li:nth-child(2) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(2)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist>li:nth-child(3) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(3)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist>li:nth-child(6) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(6)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist>li:nth-child(7) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(7)>p {
		line-height: 20px;
		margin: 0 10px;
		word-wrap: break-word;
		font-weight: 600;
		word-break: break-all
	}
	
	.tablelist::before {
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: rgba(255, 255, 255, 1);
	}
	
	.tablelist::after {
		content: "";
		display: block;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: rgba(255, 255, 255, 1);
	}
	
	.tablelist>li:before {
		content: "";
		display: block;
		width: 2px;
		height: 117px;
		position: absolute;
		top: 12px;
		right: 0;
		border-right: 2px dashed rgba(215, 217, 220, 1);
	}
	
	.tablelist>li:nth-child(1) {
		width: 10%;
		line-height: 142px;
	}
	
	.tablelist>li:nth-child(2) {
		width: 9%;
		line-height: 142px;
	}
	
	.tablelist>li:nth-child(3) {
		width: 15%;
		overflow: hidden;
	}
	
	.tablelist>li:nth-child(4) {
		width: 11%;
		line-height: 142px;
	}
	
	.tablelist>li:nth-child(5) {
		padding-top: 45px;
		width: 12%;
		height: 92px;
		position: relative;
		text-align: left;
	}
	
	.tablelist>li:nth-child(5)>p {
		cursor: pointer;
		font-size: 11px;
		font-family: PingFangSC;
		font-weight: 600;
		color: rgba(155, 155, 155, 1);
		line-height: 25px;
		margin-left: 20px;
	}
	
	.tablelist>li:nth-child(5)>p>i {
		color: rgba(0, 120, 255, 1);
		margin-right: 5px;
	}
	
	.dialogImg {
		width: 177px;
		height: 130px;
		position: absolute;
		top: 100px;
		left: -100px;
		z-index: 9999;
		border: 1px solid #CCCCCC;
		border-radius: 5px;
	}
	
	.dialogImg>img {
		width: 177px;
		height: 130px;
	}
	
	.dialogImg>i {
		display: block;
		width: 20px;
		height: 20px;
		cursor: pointer;
		font-size: 20px;
		color: #000000;
		position: absolute;
		right: 10px;
		top: 10px;
	}
	
	.tablelist>li:nth-child(6) {
		width: 13%;
		overflow: hidden;
	}
	.tablelist>li:nth-child(7) {
		width: 9%;
	}
	
	.tablelist>li:nth-child(8) {
		width: 7%;
	}
	
	.tablelist>li:nth-child(9) {
		width: 17%;
		/*line-height: 142px;*/
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.tablelist>li:nth-child(9)>div {
		width: 100px;
		height: 30px;
		margin: 0 auto;
	}
	
	.tablelist>li:nth-child(9)>div:hover button {
		border: 2px solid yellow;
	}
	
	.tablelist>li:nth-child(9)>div>button {
		float: left;
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	
	.tablelist>li:nth-child(8):before {
		display: none;
	}
	
	.tableList>li:nth-child(1) {
		width: 10%;
	}
	
	.tableList>li:nth-child(2) {
		width: 9%;
	}
	
	.tableList>li:nth-child(3) {
		width: 11%;
	}
	
	.tableList>li:nth-child(4) {
		width: 11%;
	}
	
	.tableList>li:nth-child(5) {
		width: 11%;
	}
	
	.tableList>li:nth-child(6) {
		width: 11%;
	}
	.tableList>li:nth-child(7) {
		width: 9%;
	}
	.tableList>li:nth-child(8) {
		width: 7%;
	}
	
	.tableList>li:nth-child(9) {
		width: 17%;
	}
	
	.dialogAddopple {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .3);
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.dialogAddopple>div {
		width: 312px;
		height: 268px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 4px 0px 12px 0px rgba(0, 0, 0, 0.13);
		border-radius: 10px;
		padding: 30px 30px;
	}
	
	.dialogAddopple>div>div:nth-child(1)>p:nth-child(2) {
		font-size: 18px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 25px;
	}
	
	.dialogAddopple>div>div:nth-child(1)>p:nth-child(1) {
		font-size: 20px;
		margin-bottom: 15px;
		font-weight: bold;
		overflow: hidden;
	}
	
	.addHeader {
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(241, 241, 241, 1);
	}
	
	.addCenter>p {
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		margin-top: 20px;
		margin-bottom: 5px;
	}
	
	.addCenter>div>input {
		width: 292px;
		height: 20px;
		padding: 10px;
		background: rgba(255, 255, 255, 1);
		border-radius: 8px;
		outline: none;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		border: 1px solid rgba(221, 227, 232, 1);
		margin-bottom: 15px;
	}
	
	.addFooter {
		margin-top: 30px;
	}
	
	.addFooter>div {
		width: 311px;
		height: 40px;
	}
	
	.addFooter>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.addFooter>div>button {
		width: 311px;
		height: 40px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	
	.dpcPdm ,.iputPwd{
		margin: 30px;
	}
	
	.dpcPdm>p {
		cursor: pointer;
		width: 90px;
		font-size: 15px;
		line-height: 20px;
		overflow: hidden;
		margin-bottom: 10px;
	}
	
	.dpcPdm p>i {
		float: left;
		margin-right: 10px;
	}
	.iputPwd{
		display: flex;
		align-items: center;
	}
	.iputPwd>div:nth-child(1){
		width: 300px;
	}
	.iputPwd>div:nth-child(2){
		width: 200px;
	}
	.iputPwd>div:nth-child(2) {
		width: 121px;
		height: 40px;
		margin-left: 20px;
	}
	
	.iputPwd>div:nth-child(2):hover button {
		border: 2px solid #F8E71C;
	}
	.iputPwd>div:nth-child(2)>button {
		width: 120px;
		height: 40px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 14px;
		font-family: PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	.tdcyBox {
		width: 217px;
		height: 118px;
		padding: 12px 0;
		float: left;
		margin-right: 2px;
		overflow: hidden;
	}
	
	.tdcyBox>div {
		width: 217px;
		height: 118px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		position: relative;
		border-right: 2px dashed rgba(215, 217, 220, 1);
	}
	
	.tdcyBox>div::before {
		content: "";
		display: block;
		height: 100%;
		width: 2px;
		position: absolute;
		top: 0;
		right: 0;
		/*border-right:2px dashed rgba(215, 217, 220, 1) ;*/
	}
	
	.tdcyBox>div>div {
		float: left;
	}
	
	.tdcyBox>div>div:nth-child(1) {
		padding: 10px;
		height: 98px;
		width: 74px;
	}
	
	.tdcyBox>div>div:nth-child(1)>img {
		height: 98px;
		width: 74px;
	}
	
	.tdcyBox>div>div:nth-child(2) {
		padding: 10px 5px;
	}
	
	.tdcyBox>div>div:nth-child(2)>p:nth-child(1) {
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFangSC;
		font-weight: 600;
		color: rgba(74, 74, 74, 1);
		margin: 12px 0;
	}
	
	.tdcyBox>div>div:nth-child(2)>p:nth-child(2) {
		margin-bottom: 5px;
		line-height: 15px;
	}
	
	.tdcyBox>div>div:nth-child(2)>p:nth-child(2)>i {
		float: left;
		margin-right: 5px;
	}
	
	.tdcyBox>div>div:nth-child(2)>span {
		display: block;
		width: 59px;
		height: 20px;
		background: rgba(255, 255, 255, 1);
		text-align: center;
		line-height: 20px;
		border-radius: 3px;
		border: 1px solid rgba(215, 215, 215, 1);
	}
	
	.tdcyBox>div>div:nth-child(2)>span:nth-child(3) {
		border-left: 3px solid #D4B54F;
	}
	
	.tdcyBox>div>div:nth-child(2)>span:nth-child(4) {
		border-left: 3px solid #1DB5FF;
	}
	
	.tdcyBox>div>div:nth-child(2)>span:nth-child(5) {
		border-left: 3px solid #636670;
	}
	
	.tdcyBox>div>div:nth-child(2)>.el-icon-delete-solid,
	.tdcyBox>div>div:nth-child(2)>.el-icon-refresh-right {
		font-size: 20px;
		position: absolute;
		top: 10px;
		right: 10px;
		color: red;
		cursor: pointer;
		opacity: .5;
	}
	
	.tdcyBox>div>div:nth-child(2)>.el-icon-refresh-right {
		display: none;
	}
	
	.tdcyBox>div>div:nth-child(2)>.el-icon-delete-solid:hover,
	.tdcyBox>div>div:nth-child(2)>.el-icon-refresh-right:hover {
		opacity: 1;
	}
	
	.check {
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: url(../../../assets/image/圈未选中.png) no-repeat center center;
		background-size: 100%;
	}
	
	.check.active {
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
	}
	
	.zsxxFrom {}
	
	.zsxxFrom>div:nth-child(1) {
		padding: 0 105px 0 70px;
		/*width:1075px;*/
		height: 60px;
		line-height: 60px;
		border-bottom: 2px solid #FFFFFF;
	}
	
	.zsxxFrom>div:nth-child(1)>div {
		float: right;
		width: 126px;
		height: 30px;
		margin-right: 20px;
	}
	
	.zsxxFrom>div:nth-child(1)>div:hover button {
		border: 2px solid #F8E71C;
	}
	
	.zsxxFrom>div:nth-child(1)>div>button {
		width: 126px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 16px;
		margin-top: 16px;
		cursor: pointer;
		margin-right: 10px;
	}
	
	.zsxxFrom>div>span {
		font-size: 16px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(74, 74, 74, 1);
		line-height: 23px;
	}
	
	.zsxxFrom>div:nth-child(2) {
		margin-top: 18px;
		width: 100%;
		height: 619px;
		background: rgba(255, 255, 255, .7);
		border-radius: 3px;
	}
	
	.zsxxFrom>div:nth-child(2)>div:nth-child(2) {
		float: left;
		height: 619px;
		width: 50%;
	}
	
	.fromIpt {
		height: 619px;
		width: 50%;
		float: left;
	}
	
	.fromIpt>div {
		/*width: 50%;*/
		height: 509px;
		border-right: 1px dashed rgba(215, 217, 220, 1);
		border-left: 1px solid RGBA(245, 245, 245, 1);
		padding: 55px 70px;
	}
	
	.fromIpt1>div {
		/*width: 50%;*/
		height: 509px;
		padding: 55px 70px;
	}
	
	.fromIpt>div {}
	
	.comClass>p>i,
	.comClass1>p>i,
	.comClass2>p>i {
		display: block;
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size: 100%;
		width: 15px;
		height: 15px;
		float: left;
		margin-right: 5px;
		margin-top: 4px;
	}
	
	.comClass>p,
	.comClass1>p,
	.comClass2>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
		margin-bottom: 5px;
	}
	
	.comClass,
	.comClass1 {
		margin-bottom: 20px;
	}
	
	.selectDiv,
	.selectDiv1 {
		margin-right: 10px;
		margin-bottom: 10px;
	}
	
	.selectDiv>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 20px;
	}
	
	.selectDiv1>span>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 1);
		line-height: 40px;
	}
	
	.blockDiv>div {
		width: 263px !important;
	}
	
	.blockDiv>div>.el-date-editor.el-input__inner {
		width: 263px !important;
	}
	
	.avatar-uploader {
		width: 177px;
		height: 130px;
		background: rgba(121, 139, 149, 0.44);
		box-shadow: 0px 0px 4px 0px rgba(155, 155, 155, 0.23);
		border-radius: 2px;
		text-align: center;
	}
	
	.avatar-uploader .el-icon-picture {
		font-size: 34px;
		color: #FFFFFF;
		line-height: 124px;
	}
	
	.el-upload img {
		width: 177px;
		height: 130px;
	}
	
	.comClass2 {
		margin-top: 50px;
	}
	
	.comClass2>div>div:nth-child(1) {
		margin-right: 17px;
		margin-bottom: 15px;
	}
	
	.comClass2>div>div>span {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		line-height: 23px;
	}
	.gjjiansuo{
		/*margin-left:27px ;*/
		/*display: none;*/
		overflow: hidden;
		margin-top: 11px;
		margin-bottom: 30px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.gjjiansuo>span{
		display: block;
		margin-top: 10px;
		font-size:13px;
		font-weight:500 !important;
		color:rgba(215,215,215,1);
		margin-right: 16px;
		cursor: pointer;
		border-bottom: 1px solid #D7D7D7;
	}
	.gjjiansuo>span.active{
		color: rgba(0,120,255,1);
		border-bottom: 1px solid rgba(0,120,255,1);
	}
	.gjjiansuo>span:hover{
		color: rgba(0,120,255,1);
		border-bottom: 1px solid rgba(0,120,255,1);
	}
	.tjBox{
		margin-top: 60px;
		margin-left: 20px;
		font-size: 16px;
		line-height: 20px;
	}
	.tjBox>p:last-child{
		margin-top: 20px;
	}
	.fzj{
		display: flex;
		cursor: pointer;
		width: 90px;
		font-size: 15px;
		line-height: 20px;
		overflow: hidden;
	}
	.fzjdiv{
		display: flex;
		align-items: center;
		width: 190px;
		font-size: 15px;
		line-height: 20px;
	}
	.fzjdiv>div{
		margin-left: 10px;
		width: 130px;
	}
</style>
<style type="text/css">
	.el-dialog--center .el-dialog__body{
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/MA/accountManagement/doctorList.vue